import { inject } from "@angular/core";
import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
  HttpEvent,
  HttpContextToken,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { SessionService } from "src/app/services/session.service";
import { Router } from "@angular/router";

// Context token to allow requests without authentication
export const SKIP_AUTH_TOKEN = new HttpContextToken<boolean>(() => false);

export const authTokenInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> => {
  const sessionService = inject(SessionService);
  const router = inject(Router);

  // Check if the request has context indicating auth should be skipped
  const skipAuth = req.context.get(SKIP_AUTH_TOKEN);

  return new Observable<HttpEvent<any>>((subscriber) => {
    // If skipAuth is true the token will not be added
    if (skipAuth) {
      next(req).subscribe({
        next: (event) => subscriber.next(event),
        error: (err) => subscriber.error(err),
        complete: () => subscriber.complete(),
      });
      return;
    }

    // Otherwise, retrieve the authentication token and attach it to the request
    sessionService.getToken().then((token) => {
      const authReq = token
        ? req.clone({
            setHeaders: { Authorization: token },
          })
        : req;
      next(authReq).subscribe({
        next: (event) => subscriber.next(event),
        error: (err) => {
          if (err && err.status === 401) {
            // unauthorized => redirect to login page
            // app routing mounts auth pages under /auth
            router.navigate(["/auth/login"]);
          }
          subscriber.error(err);
        },
        complete: () => subscriber.complete(),
      });
    });
  });
};
